<script setup lang="ts">
  import SidebarLink from '~/components/UI/Utilities/SidebarLink.vue';
  import SidebarSection from '~/components/UI/Utilities/SidebarSection.vue';
  const { isExpenseEnabled } = useAuth();
</script>

<template>
  <div class="flex w-full h-[calc(100vh-56px)]">
    <div class="flex flex-col min-w-[264px] max-w-[264px] w-full px-2 border-r border-zinc-200">
      <SidebarSection title="ERP4Impact Setup">
        <SidebarLink :to="'/setup'" label="Donor Types" />
        <SidebarLink v-if="isExpenseEnabled" :to="'/setup/payee_types'" label="Payee Types" />
        <SidebarLink :to="'/setup/accounting_periods'" label="Accounting Periods" />
        <SidebarLink :to="'/setup/purposes'" label="Purposes" />
        <SidebarLink :to="'/setup/stock_items'" label="Stock Items" />
        <SidebarLink :to="'/setup/org_banks'" label="Organization Bank" />
      </SidebarSection>
      <SidebarSection title="Tally Setup">
        <SidebarLink :to="'/setup/ledgers'" label="Ledgers" />
        <SidebarLink :to="'/setup/cost_centres'" label="Cost Centres" />
      </SidebarSection>
    </div>
    <div class="flex w-[calc(100%-264px)]">
      <slot />
    </div>
  </div>
</template>
